import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import OnboardingWelcomeSlide from './OnboardingWelcomeSlide';
import CloseButton from '../Buttons/CloseButton';
import OnboardingImageCarouselIntroduction from './OnboardingImageCarouselIntroduction.jsx';
import jeddleIcon from '../../static/icons/jeddle_icon.png';

// School-teacher welcome carousel: a splash slide ("Welcome to jeddAI") followed
// by the 6-slide value-prop image carousel, then it hands off to the setup
// checklist via onCloseOnboarding. The old non-school (video / starter's guide /
// classes) branch has been removed — non-school teachers and students use the
// simplified flow (SimpleOnboardingCarousel) instead.

const Container = styled.div`
  width: 100vw;
  height: 100vh;
  /* Opaque takeover matching the setup checklist (OnBoardingCompleteStyle.js)
     this hands off to — the old 60% scrim let the production sidebar (with
     the current route highlighted) and breadcrumbs show through, so users
     tried to click nav that a full-viewport overlay was swallowing. */
  background-color: rgba(241, 230, 252, 1);
  display: flex;
  align-items: center;
  justify-content: center;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1300;
`;

const ModalContainer = styled.div`
  width: 694px;
  max-width: 90%;
  background-color: white;
  border-radius: 12px;
  overflow: hidden;
  position: relative;
`;

const JeddleCorner = styled.div`
  position: absolute;
  bottom: 0;
  right: 0;
  color: #2E2177;
  padding: 8px 12px;
  display: flex;
  align-items: center;
  gap: 6px;
  font-family: var(--font-family-ibm_plex_sans);
`;

const JeddleIcon = styled.img`
  width: 26px;
  height: 26px;
`;

const JeddleText = styled.span`
  font-weight: 800;
  font-size: 20px;
`;

const TeacherOnboarding = ({ onCloseOnboarding }) => {
  const [activeSlide, setActiveSlide] = useState(0);

  useEffect(() => {
    // Inject GTM script
    const script = document.createElement('script');
    script.innerHTML = `(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
})(window,document,'script','dataLayer','GTM-P3HWKVWQ');`;
    document.head.insertBefore(script, document.head.firstChild);

    // Inject GTM noscript iframe
    const noscript = document.createElement('noscript');
    const iframe = document.createElement('iframe');
    iframe.src = 'https://www.googletagmanager.com/ns.html?id=GTM-P3HWKVWQ';
    iframe.height = '0';
    iframe.width = '0';
    iframe.style.display = 'none';
    iframe.style.visibility = 'hidden';
    noscript.appendChild(iframe);
    document.body.insertBefore(noscript, document.body.firstChild);

    return () => {
      script.remove();
      noscript.remove();
    };
  }, []);

  return (
    <Container>
      <ModalContainer>
        {/* Single, consistent close for the welcome modal — lets the user skip
            the intro straight to the setup checklist. Mirrors the X on the
            checklist + personalise popups so there's one predictable way out. */}
        <CloseButton onclickFn={onCloseOnboarding} />

        {activeSlide === 0 && (
          <OnboardingWelcomeSlide onNext={() => setActiveSlide(1)} />
        )}

        {activeSlide === 1 && (
          <OnboardingImageCarouselIntroduction onCloseOnboarding={onCloseOnboarding} />
        )}
      </ModalContainer>
      {/* Inside the fixed Container: as a fragment sibling (z-index auto) the
          wordmark painted UNDER the z-1300 Container, so the now-opaque
          backdrop would hide it. As a position:absolute child it anchors to
          the Container = viewport bottom-right, above the backdrop. */}
      <JeddleCorner>
        <JeddleIcon src={jeddleIcon} alt="Jeddle" />
        <JeddleText>jeddle</JeddleText>
      </JeddleCorner>
    </Container>
  );
};

export default TeacherOnboarding;
